





























import { StatusEnum } from '@/pages/profile/mixins';
import { LoaderMixin } from '@/pages/profile/mixins';
import { vacanciesService } from '@/services';

import { Warning, Header, Back } from '@/pages/profile/components';
import { FeedbackCard } from '@/pages/profile/blocks/cards';
import { List, InterviewCard } from '@/pages/profile/blocks/cards';
import Infotext from '@/components/parts/infotext';
import { Spinner as LoadingSpinner } from '@/components/spinners';

export default {
  name: 'Vacancy',

  components: {
    Back,
    List,
    Header,
    Warning,
    Infotext,
    FeedbackCard,
    InterviewCard,
    LoadingSpinner,
  },

  mixins: [LoaderMixin],

  data() {
    return {
      items: [],
      errorMessage: '',
      status: StatusEnum.LOADING,
      selectItems: [
        { text: 'Отклики', value: 1 },
        { text: 'Приглашения', value: 2 },
      ],
      isActivitiesInUse: 1,
    };
  },

  computed: {
    hasFeedbacks() {
      return !!this.items.length;
    },
    component() {
      const newMap = new Map([
        [1, FeedbackCard],
        [2, InterviewCard],
      ]);

      return newMap.get(this.isActivitiesInUse);
    },
  },

  metaInfo() {
    return {
      title: 'Трудоустройство',
    };
  },

  inject: ['$api'],

  async beforeMount() {
    await this.getItems();
  },

  watch: {
    async isActivitiesInUse(val, oldval) {
      if (val !== oldval) {
        console.log(val,oldval, val !== oldval);
        await this.getItems();
      }
    },
  },

  methods: {
    async getItems() {
      // TODO: methods to value map
      const fnMap = new Map([
        [1, 'getVacanciesFeedback'],
        [2, 'invitations'],
      ]);
      this.status = StatusEnum.LOADING;
      try {
        const { data } = await vacanciesService(this.$api)[
          fnMap.get(this.isActivitiesInUse)
        ]();
        this.items = data;
        this.status = StatusEnum.SUCCESS;
      } catch (err) {
        this.items = [];
        this.status = StatusEnum.SUCCESS;
      }
    },

    async cancel(id) {
      this.status = StatusEnum.LOADING;
      try {
        await vacanciesService(this.$api).postCancelVacancy(id);
        await this.getItems();
      } catch (err) {
        const [{ msg }] = err.response.data.errors;
        if (msg) this.errorMessage = msg;
        this.status = StatusEnum.ERROR;
      }
    },

    back() {
      this.errorMessage = '';
      this.status = StatusEnum.SUCCESS;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/vacancy/Vacancy.vue